module.exports = __webpack_public_path__ + "img/om.4249f749.svg";